module.exports = __webpack_public_path__ + "static/img/gallery-innerpage-img.3f346125.png";